// Pages are identified for extend by slug property
import { Device } from 'DeviceUtils';

const webItems = [
    {
        slug: 'home',
        withTvGuideButton: true,
        isHomeScreen: true,
        requiresLogin: true
    },
    {
        slug: 'my-content',
        type: 'recordings',
        requiresLogin: true
    },
    {
        slug: 'recordings',
        requiresLogin: true
    },
    {
        slug: 'videostore',
        requiresLogin: true
    },
    {
        type: 'settings',
        slug: 'settings',
        webMenuIcon: 'nav_settings',
        requiresLogin: true
    },
    {
        slug: 'bbc-player',
        requiresLogin: true
    },
    {
        slug: 'special_voyo_1',
        requiresLogin: true
    },
    {
        slug: 'special_canalplus_1',
        requiresLogin: true
    },
    {
        slug: 'dvtv-extra',
        requiresLogin: true
    }
];

const baseItems = [
    {
        slug: 'home',
        withTvGuideButton: true,
        isHomeScreen: true,
        requiresLogin: true
    },
    {
        type: 'my-content',
        slug: 'my-content',
        requiresLogin: true,
        addNonExtendedItems: false,
        items: [
            {
                type: 'recordings',
                slug: 'recordings'
            },
            {
                type: 'downloads',
                slug: 'downloads'
            }
        ],
        translations: []
    },
    {
        slug: 'recordings',
        requiresLogin: true
    },
    {
        slug: 'videostore',
        requiresLogin: true
    },
    {
        type: 'settings',
        slug: 'settings',
        requiresLogin: false
    },
    {
        slug: 'bbc-player',
        requiresLogin: true
    },
    {
        slug: 'special_voyo_1',
        requiresLogin: true
    },
    {
        slug: 'special_canalplus_1',
        requiresLogin: true
    },
    {
        slug: 'dvtv-extra',
        requiresLogin: true
    }
];

export default Device.isWeb ? webItems : baseItems;
